import { render, staticRenderFns } from "./CustomerProcessDetail.vue?vue&type=template&id=5f57c6ff&scoped=true&"
import script from "./CustomerProcessDetail.vue?vue&type=script&lang=js&"
export * from "./CustomerProcessDetail.vue?vue&type=script&lang=js&"
import style0 from "./CustomerProcessDetail.vue?vue&type=style&index=0&id=5f57c6ff&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f57c6ff",
  null
  
)

export default component.exports